import {Injectable} from '@angular/core';
import {FIELD_TYPE_DUPLICATED_BLOCK} from './FormService';

@Injectable({providedIn: 'root'})
export class DuplicateService {

  private form_fields: any[] = [];
  public FieldsThatCanBeDuplicated = []

  public DeleteField(fieldId: any) {
    const FIELD_TYPE_DUPLICATE = "duplicate_block";

    if (this.form_fields) {
      this.FieldsThatCanBeDuplicated = [];
      this.form_fields.forEach((field: any) => {

        //Clear "duplicated"fields from removed element
        if (field.field_type === FIELD_TYPE_DUPLICATE) {
          const tmpValues: any[] = [];
          const tmpOrderValues: any[] = [];
          field.field_value.forEach((v1: any) => {
            if (parseInt(v1) !== parseInt(fieldId)) {
              tmpValues.push(v1);
            }
          });
          field.order.forEach((v2: any) => {
            if (parseInt(v2) !== parseInt(fieldId)) {
              tmpOrderValues.push(v2);
            }
          });
          field.field_value = tmpValues;
          field.order = tmpOrderValues;
        }
        //Clear "duplicated"fields from removed element

        if (parseInt(field.field_id) !== parseInt(fieldId)) {
          if (![FIELD_TYPE_DUPLICATED_BLOCK].includes(field.field_type)) {
            this.FieldsThatCanBeDuplicated.push({
                key: field.field_id,
                tag: (field.field_title) ? field.field_title : 'Field-' + (parseInt(field.field_id) + 1)
              }
            );
          }
        }
      });

    }
  }

  public SetCanBeDuplicatedFields (newField: any) {
    if (!([FIELD_TYPE_DUPLICATED_BLOCK].includes(newField.field_type))) {
      this.FieldsThatCanBeDuplicated.push(
        {
          key: newField.field_id,
          tag: 'Field-' + (parseInt(newField.field_id) + 1)
        }
      );
    }
  }

  public SetFields(form_fields: any[]) {
    this.form_fields = form_fields;

    this.form_fields.forEach((v: any) => {
      if (v.field_type === FIELD_TYPE_DUPLICATED_BLOCK) {
        this.FieldsThatCanBeDuplicated.push(
          {
            key: v.field_id,
            tag: (v.field_title.trim() === '') ? 'Field-' + (parseInt(v.field_id) + 1) : v.field_title.trim()
          }
        );
      }
    })
  }

}
